// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-flipper__back-heading.tlm-flipper__back-heading{align-items:center;box-shadow:0 1px 2px 0 rgba(0,0,0,.05);box-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px -1px rgba(0,0,0,.1);display:flex;justify-content:space-between;position:sticky;top:0;z-index:1}.tlm-flipper__back-custom-scroll-fix{border-bottom:1px solid var(--v-gray-lighten1);display:block;height:1px;left:0;position:absolute;top:48px;width:5px;z-index:10}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
